<template>
  <div class="zkml-login" @keyup.enter="login" style="padding: 10px">
    <div class="login-img-wrap">
      <img src="@/assets/images/login.png" alt="" style="border-radius: 6px; width: 100%" />
      <div class="bg-img-cont">
        <img style="width: 25px" src="@/assets/images/h5/logo.png" alt="" />
        <span style="position: relative; top: -5px; left: 3px">中科碳数</span>
      </div>
      <div class="bg-img-con">
        <div style="font-size: 1.8rem" class="mb-5">欢迎登录</div>
        <div>能源管理智慧外勤</div>
      </div>
    </div>
    <div class="login_box">
      <div class="" style="margin-top: 30px">
        <div class="form_box">
          <div class="form_body">
            <div class="form_body_item">
              <!-- <div class="item_name">
                用户名
              </div> -->
              <div class="item_ipt">
                <el-input v-model.trim="form.username" prefix-icon="el-icon-user-solid" placeholder="请输入手机号"></el-input>
              </div>
            </div>
            <div class="form_body_item">
              <!-- <div class="item_name">
                密码
              </div> -->
              <div class="item_ipt">
                <el-input :type="textType" prefix-icon="el-icon-s-goods" v-model.trim="form.password" placeholder="请输入密码"></el-input>
                <span class="u-icon" :class="isText ? 'u-icon-visible' : ''" @click="iconClick"></span>
              </div>
            </div>
          </div>
          <div>
            <el-form :model="formUser" ref="formUser">
              <el-form-item prop="checkLogin" label="" :rules="[{ required: true, message: '请勾选《用户协议 和 隐私政策》', trigger: 'change' }]">
                <el-checkbox-group v-model="formUser.checkLogin">
                  <el-checkbox label="YES" class="default-style">已阅读并同意<span style="color: #2f70ff; font-size: 1.4rem" @click="userAgree">《用户协议 和 隐私政策》</span> </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </div>
          <div class="login_btn">
            <el-button class="login-button" type="primary" :loading="isLoading" @click="login">
              {{ isLoading ? '登录中' : '登录' }}
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="用户协议和隐私政策" :visible.sync="userDia" top="0" width="100%" class="pdf-dia-wrap">
      <div style="overflow-y: auto; height: 100%; overflow-x: hidden">
        <!-- <pdf v-for="i in numPages" :key="i" :src="pdfSrc" :page="i"></pdf> -->
        <div>更新日期：【2026年1月21日】</div>
        <div>更新日期：【2026年1月21日】</div>
        <div>一、前言</div>
        <div>【安徽中科碳数科技有限公司】（以下简称 “我们”）尊重并保护用户的个人信息及隐私安全。本隐私政策适用于【工单外勤】（以下简称 “外勤H5”）提供的所有服务，包括但不限于图片上传、【其他核心功能】等。</div>
        <div>我们遵循 “最小必要、公开透明” 的原则处理你的个人信息，仅为实现服务功能收集必要信息，并采取严格安全措施保护信息安全。使用外勤H5 即表示你同意本隐私政策的全部内容；若你不同意，请勿使用外勤H5。</div>
        <div>二、我们收集的个人信息及使用目的</div>
        <div>（一）图片上传功能相关信息</div>
        <div>为实现图片上传、存储、展示的核心功能，我们会在你主动操作时收集以下信息：</div>
        <div>&emsp;1.图片文件本身：你主动上传的图片内容（包括但不限于照片、截图等），仅用于你指定的用途（如【展示 / 编辑 / 分享 / 提交审核】），不会用于其他未明示的目的。</div>
        <div>&emsp;2.设备及操作相关信息：上传图片时，会临时获取设备的【存储权限（读取 / 写入）】，仅用于读取你选择的图片文件、将上传后的图片临时存储至设备缓存，权限仅在你使用该功能时生效，关闭功能后自动收回。</div>
        <div>&emsp;3.图片元数据（可选）：若你上传的图片包含拍摄时间、拍摄位置、设备型号等元数据，我们仅在【必要场景，如图片排序 / 定位】时使用，你可在上传前手动清除元数据。</div>
        <div>（二）基础运行所需信息</div>
        <div>为保障外勤H5正常运行，我们会收集设备唯一标识符（如 IMEI / 设备号）、网络类型、浏览器类型及版本，仅用于故障排查、性能优化，不会关联你的身份信息。</div>
        <div>（三）无需收集的信息</div>
        <div>除上述信息外，我们不会收集你的姓名、手机号、身份证号、地理位置（图片元数据除外）等敏感信息，除非你主动提交。</div>
        <div>三、信息的存储与保护</div>
        <div>&emsp;1.存储期限：你上传的图片及相关信息，存储期限为【长期】。</div>
        <div>&emsp;2.存储地点：所有信息均存储在中国大陆境内服务器，不会传输至境外。</div>
        <div>&emsp;3.安全措施：我们采用加密传输（HTTPS）、访问权限控制、数据脱敏等技术，防止图片及信息被泄露、篡改、丢失；仅授权必要的工作人员访问，且需签署保密协议。</div>
        <div>四、信息的共享、转让与公开披露</div>
        <div>&emsp;1.共享限制：我们不会将你的图片及相关信息共享给任何第三方，除非：</div>
        <div>&emsp;&emsp;（1）获得你的明确单独同意；</div>
        <div>&emsp;&emsp;（2）法律法规、司法机关或行政机关强制要求；</div>
        <div>&emsp;&emsp;（3）为保护用户、我们或公共安全的紧急情况。</div>
        <div>&emsp;2.转让限制：公司合并、收购等情形下，仅在确保信息保护水平不降低的前提下，方可转让你的信息，并提前通知你。</div>
        <div>&emsp;3.公开披露：不会公开披露你的图片及相关信息，除非获得你的单独同意。</div>
        <div>五、你的权利</div>
        <div>你可通过以下方式行使个人信息相关权利：</div>
        <div>&emsp;注销 / 清除数据：联系客服（【15755506132】）申请清除所有上传的图片及相关数据，我们会在 15 个工作日内完成处理并反馈。</div>
        <div>六、未成年人保护</div>
        <div>外勤H5不向未成年人提供服务（或：若面向未成年人，需获取监护人同意后方可上传图片，且仅收集必要信息，监护人可联系我们查阅 / 删除未成年人上传的图片）。</div>
        <div>七、隐私政策的更新</div>
        <div>我们可能根据业务调整或法规变化更新本政策，更新后会在外勤H5首页显著位置提示，重大变更会另行通知（如弹窗 / 短信）。</div>
        <div>八、联系我们</div>
        <div>若你对本政策或信息处理有任何疑问、投诉，可通过以下方式联系我们：</div>
        <div>&emsp;1.客服电话：【15755506132】</div>
        <div>&emsp;2.客服邮箱：【jiangt@izkts.com】</div>
        <div>&emsp;我们会在 15 个工作日内回复你的诉求。</div>
      </div>
    </el-dialog>

    <password-dia ref="passwordRef"></password-dia>
  </div>
</template>

<script>
// import md5 from "js-md5" // 处理登录时密码的加密
import { sm3 } from 'sm-crypto';
import cookie from '@/utils/cookie';
import uuid from '@/utils/uuid';
import { Base64 } from 'js-base64';
import wx from 'weixin-js-sdk';
import pdf from 'vue-pdf';
import passwordDia from '@/views/password.vue';
export default {
  components: {
    'password-dia': passwordDia,
    pdf,
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
        code: '',
      },
      formUser: {
        checkLogin: [],
      },
      isLoading: false,
      rememberChecked: false,
      isText: false,
      textType: 'password',
      loginBg: '',
      identifyCode: '',
      identifyCodes: '0123456789qwertyuiopasdfghjklzxcvbnm',

      userDia: false,
      pdfSrc: null,
      numPages: undefined,
    };
  },
  created() {
    this.getCheck();
  },
  methods: {
    //密码隐藏与显示
    iconClick() {
      if (this.isText) {
        this.textType = 'password';
      } else {
        this.textType = 'text';
      }
      this.isText = !this.isText;
    },
    // 是否勾选记住密码
    getCheck() {
      this.rememberChecked = false;
      this.form.username = cookie.get('task_username');
      if (cookie.get('task_psd')) {
        let password = Base64.decode(cookie.get('task_psd'));
        this.form.password = password.substring(20, password.length);
      }
      if (this.form.password) this.rememberChecked = true;
    },
    // 登录
    login() {
      if (!this.form.username) {
        return this.$message.error('用户名不能为空');
      } else if (!this.form.password) {
        return this.$message.error('密码不能为空');
      }
      let params = {
        username: this.form.username,
        password: sm3(this.$md5(this.form.password)),
        openId: sessionStorage.getItem('openId'),
      };

      this.$refs.formUser.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          this.$http
            .post(this.$API.mlyun_auth_server_auth_safelogin, params)
            .then(async ({ success, data, errCode, message }) => {
              if (success) {
                sessionStorage.setItem('token', data.token);

                this.$store.dispatch('app/updateLoginInfo', {
                  userInfo: data,
                });
                sessionStorage.setItem('userInfo', JSON.stringify(data));
                this.$router.push({ path: '/home' });
              } else {
                // 第一次登录修改密码
                if (errCode == 'PASSWORD_RESET_WITH_FIRSTLOGIN' || errCode == 'PASSWORD_EXPIRE') {
                  this.isLoading = false;
                  this.$message.error(message);
                  this.$refs.passwordRef.openModal(this.form.username, 'login');
                } else {
                  this.isLoading = false;
                  this.$message.error(message);
                }
              }
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    userAgree() {
      this.userDia = true;
      // this.loadPdf();
    },
    async loadPdf() {
      const loadingTask = pdf.createLoadingTask('http://123.60.131.44:50021/files/prod/energy-carbon/20260121/b3bb5da324724269bafd3c773ec54e92.pdf');
      this.pdfSrc = loadingTask;
      try {
        const pdf = await loadingTask.promise;
        this.numPages = pdf.numPages;
      } catch (error) {
        console.error('PDF加载失败', error);
      }
    },
  },
};
</script>

<style lang="scss">
.default-style {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #606266;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #2f70ff;
    border-color: #2f70ff;
  }
}
.pdf-dia-wrap {
  &.el-dialog__wrapper {
    overflow-x: hidden;
  }
}
</style>
<style lang="scss" scoped>
.form-code-wrap {
  display: flex;
  justify-content: space-between;
  .form-code {
    width: 150px;
    height: 40px;
    cursor: pointer;
  }
}
.backstretch {
  left: 0px;
  top: 0px;
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: fixed;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .video-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0, 8, 62, 0.5);
  }
}
.login-img-wrap {
  position: relative;
  .bg-img-cont {
    position: absolute;
    top: 10px;
    left: 10px;
    color: #fff;
  }
  .bg-img-con {
    position: absolute;
    bottom: 15px;
    right: 15px;
    color: #fff;
    text-align: right;
  }
}
.font1 {
  font-size: 2rem;
  color: 000;
}
.font2 {
  font-size: 1.8rem;
  color: 000;
}
.font4 {
  font-size: 1.6rem;
  color: 000;
}
.font3 {
  font-size: 1.4rem;
  color: 000;
}
</style>
<style scoped src="./login.css"></style>
